import * as React from 'react';
import styled from 'styled-components';
import { KEYS } from '../../../constants/keys.js';
import { useTranslations } from '../../../hooks/use_translations.js';
import { spacing1x } from '../../../styles/spacing.js';
import { useThemeContext } from '../../../styles/themes/themes.js';
import { Button } from '../../Button/Button.js';
import { IconCheck } from '../../Icons/IconCheck.js';
import { IconClose } from '../../Icons/IconClose.js';
import { A2E_DATA_TESTIDS } from '../constants.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var WriteViewContainer = styled.div.withConfig({
  displayName: "ActivateToEditWriteView__WriteViewContainer",
  componentId: "sc-140fde2-0"
})(["&&{position:relative;border-radius:", ";box-sizing:border-box;display:flex;min-height:32px;}"], spacing1x);
var WriteButtons = styled.div.withConfig({
  displayName: "ActivateToEditWriteView__WriteButtons",
  componentId: "sc-140fde2-1"
})(["&&{display:flex;gap:", ";position:absolute;inset-inline-end:", ";}"], spacing1x, spacing1x);
var ActivateToEditWriteView = function ActivateToEditWriteView(_ref) {
  var ariaLabel = _ref["aria-label"],
    children = _ref.children,
    hasValidationError = _ref.hasValidationError,
    onCancelEdit = _ref.onCancelEdit,
    onConfirmEdit = _ref.onConfirmEdit;
  var _useThemeContext = useThemeContext(),
    localization = _useThemeContext.localization;
  var _useTranslations = useTranslations(localization === null || localization === void 0 ? void 0 : localization.translations),
    t = _useTranslations.t;
  var writeViewRef = React.useRef(null);
  var onWriteViewKeyDown = function onWriteViewKeyDown(event) {
    switch (event.key) {
      case KEYS.SPACE:
      case KEYS.ENTER:
        event.stopPropagation();
        break;
      case KEYS.ESCAPE:
        event.preventDefault();
        onCancelEdit();
        break;
    }
  };
  var onWriteViewBlur = function onWriteViewBlur(event) {
    var _writeViewRef$current;
    if (event.relatedTarget && (_writeViewRef$current = writeViewRef.current) !== null && _writeViewRef$current !== void 0 && _writeViewRef$current.contains(event.relatedTarget)) {
      return;
    }
    onCancelEdit();
  };
  return /*#__PURE__*/jsxs(WriteViewContainer, {
    "aria-label": ariaLabel,
    ref: writeViewRef,
    onBlur: onWriteViewBlur,
    onKeyDown: onWriteViewKeyDown,
    onKeyUp: function onKeyUp(event) {
      return event.preventDefault();
    },
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    "data-testid": A2E_DATA_TESTIDS.writeViewContainer,
    children: [children, /*#__PURE__*/jsxs(WriteButtons, {
      children: [/*#__PURE__*/jsx(Button, {
        label: t("ActivateToEdit.cancelLabel"),
        variant: "tertiary",
        startAdornment: IconClose,
        hideLabel: true,
        onClick: function onClick() {
          return onCancelEdit();
        }
      }), /*#__PURE__*/jsx(Button, {
        label: t("ActivateToEdit.confirmLabel"),
        startAdornment: IconCheck,
        hideLabel: true,
        variant: hasValidationError ? "tertiary" : "primary",
        onClick: function onClick() {
          return onConfirmEdit();
        }
      })]
    })]
  });
};

export { ActivateToEditWriteView };
